import React, {useState} from "react";

import {OrganisationId} from "common/types/organisation";
import {AggregatedWorkflowTest} from "common/flowmaster/types/test";
import {LlmRunFilterKeys} from "common/flowmaster/types/llm_run";
import {LlmRunQueryParams} from "routes/llm_run/utils/filtering/get_llm_run_query_params";

import Summary from "./summary";
import Settings from "./settings";
import Filters from "./filters";
import TestsTable from "./tests_table";

interface Props {
  organisationId: OrganisationId;
  workflowTests: AggregatedWorkflowTest[];
  filters: LlmRunQueryParams;
  updateValue: (obj: Record<LlmRunFilterKeys, string | number>) => void;
}

export default function Tests({
  organisationId,
  workflowTests,
  filters,
  updateValue,
}: Props) {
  const [groupResults, setGroupResults] = useState(true);
  const [showOnlyDataAssets, setShowOnlyDataAssets] = useState(true);
  const [showArchived, setShowArchived] = useState(false);
  const filteredWorkflowTests = workflowTests.filter(
    test =>
      test.is_data_asset === showOnlyDataAssets &&
      (showArchived || !test.is_archived),
  );
  return (
    <div style={{padding: "0.5em"}}>
      <div style={{display: "flex", justifyContent: "space-between"}}>
        <h1>LLM Tests</h1>
      </div>
      <div style={{display: "flex", justifyContent: "space-between"}}>
        <Summary workflowTests={filteredWorkflowTests} />
        <Settings
          groupResults={groupResults}
          setGroupResults={setGroupResults}
          showOnlyDataAssets={showOnlyDataAssets}
          setShowOnlyDataAssets={setShowOnlyDataAssets}
          showArchived={showArchived}
          setShowArchived={setShowArchived}
        />
        <Filters
          filters={filters}
          updateValue={updateValue}
          keys={[
            "workflow",
            "project",
            "issue",
            "config",
            "document",
            "clausepart",
          ]}
        />
      </div>
      <TestsTable
        organisationId={organisationId}
        workflowTests={filteredWorkflowTests}
        updateValue={updateValue}
        groupResults={groupResults}
      />
    </div>
  );
}
